import { render, staticRenderFns } from "./EditBusinessInformationView.vue?vue&type=template&id=2cc203f6&"
import script from "./EditBusinessInformationView.vue?vue&type=script&lang=js&"
export * from "./EditBusinessInformationView.vue?vue&type=script&lang=js&"
import style0 from "./EditBusinessInformationView.vue?vue&type=style&index=0&id=2cc203f6&prod&lang=scss&"
import style1 from "v-calendar/lib/v-calendar.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports